import React from 'react';
import { Link } from 'react-router-dom';

import { swiper0, swiper1, swiper2, swiper3, swiper4, swiper5, swiper6, mbSwiper1, mbSwiper2, } from '../../assets/images/main/mainImages';
import { prdBlack1, prdBlack2, prdBlack3, prdBlack4, prdWhite1, prdWhite2, prdWhite3, prdWhite4, prdReader, prdTag, prdIcCard, prdPrinter } from '../../assets/images/main/mainImages';
import { sol1, sol2, sol3, sol4 } from '../../assets/images/main/mainImages';
import { field1, field2, field3, field4, field5 } from '../../assets/images/main/mainImages'


//1p. SwiperSlide Data
export const swiperSlides = [
  {
    title: (<>“RFID/NFC 특수 인쇄 카드”<br />다양한 재질과 인쇄방식<br />용도에 맞는 특수 제작</>),
    text: (
      <>
        회원카드, 객실카드, 사원증, 포토카드<br />
        유광, 무광, UV인쇄, 금/은박, 홀로그램<br />
        금속, 방수, 투명 등 고급스럽고 특수한 재질의<br />
        다양한 RFID, NFC 카드 제작
        <Link className='text-line-none' to={'/product/list?list=25&pageIdx=1'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper6,
  },
  {
    title: (<>ISO14443/15693 지원<br />듀얼 NFC R/W리더기<br />“ACR-1552U” “ACR-1555U”</>),
    text: (
      <>
        CCID & PC/SC표준 API사용, SAM슬롯 장착<br />
        키보드 애뮬레이션 모드 지원<br />
        ACR1555U Bluetooth 5.2 지원
        <div className='flex-row'>
          <Link className='text-line-none' to={'/product/detail?idx=135&list=1'}>
            <div className='swiper-view-vtn'>
              ACR1552U<br />view
            </div>
          </Link>
          <div className='mr-30'></div>
          <Link className='text-line-none' to={'/product/detail?idx=133&list=1'}>
            <div className='swiper-view-vtn'>
              ACR1555U<br />view
            </div>
          </Link>
        </div>
        
      </>
    ),
    image: swiper5,
  },
  {
    title: (<>“모바일 신분증” 인증 장비<br />지자체 공식 독점 납품</>),
    text: (
      <>
        “모바일 신분증, 운전면허증,<br />
        국가보훈등록증, 외국인등록증 등”<br />
        NFC리더기 ACR-1252U<br />
        LCD보안 키패드 EPR-022K
        <Link className='text-line-none' to={'/portfolio/partner/detail/5'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper4,
  },
  {
    title: 'RFID/NFC 리더기 전문',
    text: (
      <>
        다양한 통신방식/주파수/사용환경/사용용도<br />
        사용자들의 편의에 맞춰 범용적으로<br />
        사용 가능한 리더기
        <Link className='text-line-none' to={'/product/list?list=1&pageIdx=1'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper0,
  },
  {
    title: (<>RFID/NFC 카드&태그<br />다양한 재질,사이즈<br />커스텀 제작</>),
    text: (
      <>
        고온/금속/방수/특수재질 등<br />
        사용환경에 맞춘 커스텀<br />
        RFID/NFC 카드&태그 제작
        <Link className='text-line-none' to={'/product/list?list=7&pageIdx=1'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper1,
  },
  {
    title: 'SOLUTION',
    text: (
      <>
        RFID/NFC 근태관리 / 출결관리 솔루션 / Encoing <br />
        Hardware+Softeware 기술력으로 솔루션을 제공
        <Link className='text-line-none' to={'/solution/attend'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper2,
  },
  {
    title: 'PORTFOLIO',
    text: (
      <>
        모바일 운전면허증, 신분증 발급용<br />
        NFC / 키패드 단말기 뿐만 아니라<br />
        기타 관공서 , 기업 전용 특수태그 등<br />
        엠포플러스의 납품현황을 소개합니다.
        <Link className='text-line-none' to={'/portfolio/partner/1'}>
          <div className='swiper-view-vtn'>
            view
          </div>
        </Link>
      </>
    ),
    image: swiper3,
  },
];

//2p. Product Data
export const prdCards = [
  {
    title: 'RFID/NFC 리더기',
    content:(
      <>
        다양한 주파수 및 인터페이스의 리더기를 보유하고 있으며,<br />
        SDK, Demo 제공은 기본 원활한 기술상담을 해드립니다.
      </>
    ),
    imgPath: prdWhite1,
    wrapClass: 'prd-card-div1 main-trans-l-r',
    innerDivClass: 'prd-in-card-div',
    titleClass: 'prd-card-title',
    contentClass: 'prd-card-content',
    imgClass: 'prd-card-img',
    linkUrl: '/product/list?list=1&pageIdx=1'
  },
  {
    title: 'RFID/NFC 태그',
    content:(
      <>
        125KHz, 13.56MHz, 900MHz<br />
        의 주파수를 취급하고 있으며,<br />
        원하는 형태 및 재질로 커스터<br />
        마이징이 가능합니다.
      </>
    ),
    imgPath: prdBlack2,
    wrapClass: 'prd-card-div2 main-trans-r-l',
    innerDivClass: 'prd-in-card-div',
    titleClass: 'prd-card-title',
    contentClass: 'prd-card-content',
    imgClass: 'prd-card-img',
    linkUrl: '/product/list?list=22&pageIdx=1'
  },
  {
    title: 'IC 리더기/카드',
    content:(
      <>
        보안이 강화된 결제시스템에<br />
        활용할 수 있는 IC 리더기 및 <br />
        카드를 제공합니다.
      </>
    ),
    imgPath: prdBlack3,
    wrapClass: 'prd-card-div2 main-trans-l-r',
    innerDivClass: 'prd-in-card-div',
    titleClass: 'prd-card-title',
    contentClass: 'prd-card-content',
    imgClass: 'prd-card-img',
    linkUrl: '/product/list?list=34&pageIdx=1'
  },
  {
    title: 'RFID/CARD 프린터',
    content:(
      <>
        직접 출력하여 현업에 응용 <br />
        가능한 RFID 라벨프린터 및 <br />
        카드프린터를 제공합니다.
      </>
    ),
    imgPath: prdBlack4,
    wrapClass: 'prd-card-div2 main-trans-r-l',
    innerDivClass: 'prd-in-card-div',
    titleClass: 'prd-card-title',
    contentClass: 'prd-card-content',
    imgClass: 'prd-card-img',
    linkUrl: '/product/list?list=36&pageIdx=1'
  },
];

//3p. Solution Data
export const circleBorderCards = [
  {
    content: 'NFC 인코딩솔루션',
    imgPath: sol1,
    wrapClass: 'main-trans-b-t main-sol-card-wrap',
    imgClass: 'sol-circle-img',
    contentClass: 'sol-circle-content',
    url: '/solution/nfc',
  },
  {
    content: 'R/W 솔루션',
    imgPath: sol2,
    wrapClass: 'main-trans-b-t main-sol-card-wrap',
    imgClass: 'sol-circle-img',
    contentClass: 'sol-circle-content',
    url: '/solution/rfid',
  },
  {
    content: '근태관리솔루션',
    imgPath: sol3,
    wrapClass: 'main-trans-b-t main-sol-card-wrap',
    imgClass: 'sol-circle-img',
    contentClass: 'sol-circle-content',
    url: '/solution/attend',
  },
  {
    content: '출결관리솔루션',
    imgPath: sol4,
    wrapClass: 'main-trans-b-t main-sol-card-wrap',
    imgClass: 'sol-circle-img',
    contentClass: 'sol-circle-content',
    url: '/solution/school',
  },
];

//6p. Field Data
export const circleCards = [
  {
    title: '보안성',
    content: (
      <>
        중복 되지 않는 Tag의<br />
        UID 값을 활용 하기 때문에<br />
        출입통제 및 각종 보안에 용이함.
      </>
    ),
    wrapClass: 'circle1 circle-box main-trans-r-l',
    titleClass: 'circle-title',
  },
  {
    title: '편리성',
    content: (
      <>
        Tag의 Chip과 Antena를<br />
        사용하여 Tag를 인식하기 때문에<br />
        복수의 Tag를 인식이 가능하며,<br />
        경우에 따라 사용자가 원하는<br />
        정보를 Tag에 Write가 가능.
      </>
    ),
    wrapClass: 'circle2 circle-box main-trans-r-l',
    titleClass: 'circle-title',
  },
  {
    title: '활용성',
    content: (
      <>
        900Mhz 대역을 사용할 경우<br />
        멀리 떨어진 곳의<br />
        Tag도 인식이 가능하여<br />
        재고관리에 탁월함.
      </>
    ),
    wrapClass: 'circle3 circle-box main-trans-r-l',
    titleClass: 'circle-title',
  },
  
];

export const fieldCards = [
  {
    title: '유통/물류/운송',
    imgPath: field1,
    wrapClass: 'main-rn-field-0 main-trans-r-l field-card-div',
    titleClass: 'field-card-title',
    cardLineClass: 'field-card-line',
    cardImgClass: 'field-card-img',
  },
  {
    title: '산업분야',
    imgPath: field2,
    wrapClass: 'main-rn-field-1 main-trans-r-l field-card-div',
    titleClass: 'field-card-title',
    cardLineClass: 'field-card-line',
    cardImgClass: 'field-card-img',
    
  },
  {
    title: '공공분야',
    imgPath: field3,
    wrapClass: 'main-rn-field-2 main-trans-r-l field-card-div',
    titleClass: 'field-card-title',
    cardLineClass: 'field-card-line',
    cardImgClass: 'field-card-img',
  },
  {
    title: '금융분야',
    imgPath: field4,
    wrapClass: 'main-rn-field-3 main-trans-r-l field-card-div',
    titleClass: 'field-card-title',
    cardLineClass: 'field-card-line',
    cardImgClass: 'field-card-img',
  },
  {
    title: '약품 및 농업물',
    imgPath: field5,
    wrapClass: 'main-rn-field-4 main-trans-r-l field-card-div',
    titleClass: 'field-card-title',
    cardLineClass: 'field-card-line',
    cardImgClass: 'field-card-img',
  },
];